import {
  SET_ACTION_COUNT_CHECK,
  SET_ACTION_ERROR,
  SET_ACTION_LOADING,
  SET_ACTION_MODAL_OPEN,
  SET_ACTION_RESET,
  SET_ACTION_SUCCESS,
  SET_ACTION_SUCCESS_ALERT_MESSAGE,
  SET_CERT_DETAILS_VIEW_CERT_AUTO_REVOKE_LIST,
  SET_CERT_DETAILS_VIEW_CERT_END_DATE,
  SET_CERT_DETAILS_VIEW_CERT_START_DATE,
  SET_CONSULT_ACTION_ASSIGNEE_LIST,
  SET_CONSULT_ACTION_ASSIGNEE_LIST_ERROR,
  SET_CONSULT_ACTION_ASSIGNEE_LIST_LOADING,
  SET_ENABLE_INDIVIDUAL_COMMENTS,
  SET_IS_REASSIGN_POPOVER_MSG,
  SET_IS_REASSIGN_WARN_MSG_OPENED,
  SET_REASSIGN_CONFIG,
  SET_VERIFY_PARENT_ERROR,
  SET_VERIFY_PARENT_LOADING,
  SET_VERIFY_PARENT_MAP,
} from '../types';

/* eslint-disable default-param-last */
const INITIAL_STATE = {
  isVerifyParentLoading: false,
  isAtLeastThreeActions: false,
  verifyParentMap: [],
  isActionLoading: false,
  isActionSuccess: false,
  // TODO: @Jacob, Maybe refator or remove this based on current usage
  isActionError: false,
  isActionModalOpen: false,
  errorMessage: null,
  // TODO: @Jacob, END
  // TODO: @Vishnu, These default messages are requirment from UX for when the backend does not supply a message. Bring them back after you flag update
  // criticalAlertMessage: {
  //   title: 'Network Error',
  //   description:
  //     'Something went wrong due to a problem with the network. Try refreshing your page.',
  //   colorTheme: 'Critical',
  // },
  criticalAlertMessage: {
    title: null,
    description: null,
    colorTheme: 'Critical',
  },
  userKey: null,
  buttonActionType: null,
  certificationStartDate: null,
  certificationEndDate: null,
  autoRevokeWarningList: [],
  reassignConfigMap: {},
  isPopoverUserReassignMsgShown: false,
  isWarnModalReassignShown: false,
  consultActionAssignee: {
    assigneeList: [],
    isLoading: true,
    errorMessage: null,
  },
  enableComments: {
    users: [],
    accEntRole: [],
    accounts: [],
    entitlements: [],
    childEntilements: [],
    roles: [],
  },
};

const lineActionsReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_VERIFY_PARENT_LOADING:
      return {
        ...state,
        isVerifyParentLoading: action.payload,
      };

    case SET_VERIFY_PARENT_MAP:
      return {
        ...state,
        isVerifyParentLoading: false,
        verifyParentMap: action.payload,
      };

    case SET_VERIFY_PARENT_ERROR:
      return {
        ...state,
        criticalAlertMessage: {
          title: 'Verification Failed',
          description:
            'The parent of this access item could not be verified. Try again.',
          colorTheme: 'Critical',
        },
        isVerifyParentLoading: false,
        isActionLoading: false,
        isActionSuccess: false,
        isActionError: true,
        errorMessage: action.payload.error,
        buttonActionType: null,
      };

    case SET_ACTION_SUCCESS_ALERT_MESSAGE:
      return {
        ...state,
        criticalAlertMessage: {
          title: action.payload.title,
          description: action.payload.description,
          colorTheme: action.payload?.theme ? action.payload.theme : 'Success',
        },
      };

    case SET_ENABLE_INDIVIDUAL_COMMENTS:
      return {
        ...state,
        enableComments: {
          users: action.payload.enableIndividualCommentsForUsers || [],
          accEntRole:
            action.payload.enableIndividualCommentsForAccountEntitlementRoles ||
            [],
          accounts: action.payload.enableIndividualCommentsForAccounts || [],
          entitlements:
            action.payload.enableIndividualCommentsForEntitlements || [],
          childEntilements:
            action.payload.enableIndividualCommentsForChildEnt || [],
          roles: action.payload.enableIndividualCommentsForRoles || [],
        },
      };

    case SET_ACTION_COUNT_CHECK:
      return {
        ...state,
        isAtLeastThreeActions: action.payload,
      };

    case SET_ACTION_LOADING:
      return {
        ...state,
        isActionLoading: true,
        isActionSuccess: false,
        isActionError: false,
        errorMessage: null,
        buttonActionType: action.payload ? action.payload : null,
      };

    case SET_ACTION_SUCCESS:
      return {
        ...state,
        isActionLoading: false,
        isActionSuccess: true,
        isActionError: false,
        errorMessage: null,
      };

    case SET_ACTION_RESET:
      return {
        ...state,
        isActionLoading: false,
        isActionSuccess: false,
        isActionError: false,
        errorMessage: null,
        buttonActionType: null,
      };

    case SET_ACTION_ERROR:
      return {
        ...state,
        // TODO: Make these acti dynamic using payload
        criticalAlertMessage: {
          title: action?.payload?.title
            ? action?.payload?.title
            : 'Network Error',
          description: action?.payload?.error
            ? action.payload.error
            : 'Something went wrong. Please try again.',
          colorTheme: action?.payload?.colorTheme
            ? action?.payload?.colorTheme
            : 'Critical',
        },
        isActionLoading: false,
        isActionSuccess: false,
        isActionError: true,
        errorMessage: action.payload.error,
        buttonActionType: null,
      };

    case SET_ACTION_MODAL_OPEN:
      return {
        ...state,
        isActionModalOpen: action.payload,
      };

    case SET_CERT_DETAILS_VIEW_CERT_START_DATE:
      return {
        ...state,
        certificationStartDate: action?.payload,
      };

    case SET_CERT_DETAILS_VIEW_CERT_END_DATE:
      return {
        ...state,
        certificationEndDate: action?.payload,
      };

    case SET_CERT_DETAILS_VIEW_CERT_AUTO_REVOKE_LIST:
      return {
        ...state,
        autoRevokeWarningList: action?.payload,
      };

    case SET_REASSIGN_CONFIG:
      return {
        ...state,
        reassignConfigMap: action.payload,
      };

    case SET_IS_REASSIGN_POPOVER_MSG:
      return {
        ...state,
        isPopoverUserReassignMsgShown:
          action.payload === false ? action.payload : true,
      };

    case SET_IS_REASSIGN_WARN_MSG_OPENED:
      return {
        ...state,
        isWarnModalReassignShown: !state.isWarnModalReassignShown,
      };

    case SET_CONSULT_ACTION_ASSIGNEE_LIST:
      return {
        ...state,
        consultActionAssignee: {
          ...state.consultActionAssignee,
          assigneeList: action.payload.data,
          errorMessage: null,
        },
      };

    case SET_CONSULT_ACTION_ASSIGNEE_LIST_LOADING:
      return {
        ...state,
        consultActionAssignee: {
          ...state.consultActionAssignee,
          isLoading: action.payload,
        },
      };

    case SET_CONSULT_ACTION_ASSIGNEE_LIST_ERROR:
      return {
        ...state,
        consultActionAssignee: {
          ...state.consultActionAssignee,
          errorMessage: action.payload,
        },
      };

    default:
      return state;
  }
};

export default lineActionsReducer;
